import React, { useState } from 'react';
import { ShopSelectorHeader } from './ShopSelectorHeader';
import { Grid } from '../../UI/Grid/grid';
import { IInput, ILabel, IShop } from '../../../utils/types/contentful';
import { formatContentfulComponentProps } from '../../../utils/globals';
import { Button } from '../../UI/Elements';

export interface IShopSelectorProps {
  label: ILabel;
  input: IInput;
  shops: Array<IShop>;
}

export const ShopSelector: React.FC<IShopSelectorProps> = ({ list }) => {
  const [collection, setCollection] = useState(0);

  return (
    <>
      <ShopSelectorHeader
        collection={collection}
        setCollection={setCollection}
        list={list.items}
      />
      <Grid
        key={collection}
        grid={{
          wrap: true,
          isSlider: 'block',
          itemsWidth:
            'min-w-10/12 md:w-1/2 md:min-w-5/12 xl:w-1/4 xl:min-w-1/4',
          gridItems: formatContentfulComponentProps(list.items[collection]).grid
            .gridItems,
        }}
      />
      <div className='mt-10'>
        <Button
          {...formatContentfulComponentProps(list.items[collection]).button}
          size='lg'
        />
      </div>
    </>
  );
};
